import { fetchJSON } from '@bonnet/core/fetch';

import { cmApiUrl } from '@atc/cm-api-url';

export default async (query = {}) => {
    const trimData = await fetchJSON(cmApiUrl('/rest/lsc/crawl/newtrims'), {
        circuitBreaker: {
            id: 'crawlPathNewTrim',
            timeout: 3000,
            resetTimeout: 300000,
            fallback: {
                error: 'Circuit Breaker for /rest/lsc/crawl/newtrims is open',
            },
        },
        query,
        headers: {
            'X-fwd-svc': 'atc',
        },
    });
    return trimData || {};
};
